if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll("input");
      this.variantLabel = this.querySelector(".variant__label--select-variant");
      this.enabledDescription = this.getAttribute("data-enabled-description") === "true" ? true : false;
      this.metafieldDescription = this.querySelector(".variant__label--metafield-description");
      this.mainGallery = document.querySelector(".product-gallery");
      this.mainGalleryMetafield = document.querySelector(".product-gallery-metafields");
      this.mainSlideshow = this.mainGalleryMetafield?.querySelector(".product-slideshow");
      this.thumbsContainer = this.mainGalleryMetafield?.querySelector(".product__thumbs--scroller");
      this.productSection = document.querySelector(".product-section");
      this.currentVariant = this.productSection?.getAttribute("data-current-variant-id");
      this.enableVariantOutside = this.getAttribute("data-enabled-variant-outside") === "true" ? true : false;
      this.flkty = null;

      this.init();
    }

    init() {
      // Verifica APENAS o próprio elemento, não filhos
      const is_bundle = this.classList.contains("product-block__is-bundle");
      const is_upsell = this.classList.contains("upsell__is_bundle");
      if (is_bundle || is_upsell) return;

      this.inputs.forEach((input) => {
        input.addEventListener("change", (event) => {
          this.changeVariant(event.target);
        });
      });

      window.addEventListener("resize", () => {
        if (this.mainSlideshow?.flickityInstance) {
          this.mainSlideshow?.flickityInstance.resize();
        }
      });

      // Inicializa com a variante atual selecionada pela url
      if (this.enableVariantOutside) {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant");

        if (variantId) {
          const variant_input = this.querySelector(`input[data-variant-id="${variantId}"]`);
          variant_input.click();
          this.changeVariant(variant_input);
        }
      }
    }

    changeVariant(variant) {
      this.updateMetafieldDescription(variant);
      // this.updateSelectedLabel(variant);
      if (this.mainGalleryMetafield) {
        this.updateGallery(variant);
      }
    }

    updateSelectedLabel(variant) {
      const value = variant?.getAttribute("value");
      this.variantLabel.textContent = value;
    }

    updateMetafieldDescription(variant) {
      if (this.enabledDescription) {
        const description = variant?.getAttribute("data-metafield-description") || "";

        if (description) {
          this.metafieldDescription.textContent = description;
          this.metafieldDescription.classList.remove("hidden");
        } else {
          this.metafieldDescription.textContent = "";
          this.metafieldDescription.classList.add("hidden");
        }
      }
    }

    updateGallery(variant) {
      const imagesJson = variant.getAttribute("data-localized-images");

      this.mainGallery = document.querySelector(".product-gallery-desktop");
      this.mainGalleryMetafield = document.querySelector(".product-gallery-metafields");
      this.mainSlideshow = this.mainGalleryMetafield?.querySelector(".product-slideshow");
      this.thumbsContainer = this.mainGalleryMetafield?.querySelector(".product__thumbs--scroller");

      if (!imagesJson || imagesJson === "[]" || imagesJson === "") {
        this.mainGalleryMetafield?.classList.add("hidden");
        this.mainGallery?.classList.remove("hidden");

        if (this.mainSlideshow?.flickityInstance) {
          try {
            this.mainSlideshow.flickityInstance.destroy();
          } catch (e) {
            console.warn("Erro ao destruir Flickity anterior:", e);
          }
          this.mainSlideshow.flickityInstance = null;
        }
        return;
      }

      this.mainGalleryMetafield?.classList.remove("hidden");
      this.mainGallery?.classList.add("hidden");

      let mediaItems;
      try {
        mediaItems = JSON.parse(imagesJson);
      } catch (err) {
        console.warn("Erro ao parsear imagens:", err);
        return;
      }

      if (!mediaItems?.length) return;

      if (this.mainSlideshow?.flickityInstance) {
        try {
          this.mainSlideshow.flickityInstance.destroy();
        } catch (e) {
          console.warn("Erro ao destruir Flickity anterior:", e);
        }
        this.mainSlideshow.flickityInstance = null;
      }

      this.mainSlideshow.innerHTML = "";
      this.thumbsContainer.innerHTML = "";

      mediaItems.forEach((item, index) => {
        const { url, type } = item;
        const isVideo = type === "video";

        const slide = document.createElement("div");
        slide.className = `product-main-slide secondary-slide${index === 0 ? " is-selected" : ""}`;
        slide.dataset.index = index;

        slide.innerHTML = isVideo
          ? `
            <div class="video-wrap" style="height:0;padding-bottom:100%;position:relative;">
              <video
                class="product-video"
                src="${url}"
                playsinline
                muted
                loop
                controls
                style="width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;"
              ></video>
            </div>`
          : `
            <div class="image-wrap" style="height:0;padding-bottom:100%;">
              <img
                class="photoswipe__image lazyautosizes"
                data-photoswipe-src="${url}"
                data-photoswipe-width="800"
                data-photoswipe-height="800"
                data-index="${index}"
                alt=""
                loading="lazy"
                src="${url}"
              >
              <a href="${url}" type="button" class="btn btn--body btn--circle product__photo-zoom glightbox" data-gallery="product-gallery">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64">
                  <path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"></path>
                </svg>
              </a>
            </div>`;

        this.mainSlideshow.appendChild(slide);

        const thumbItem = document.createElement("div");
        thumbItem.className = "product__thumb-item";
        thumbItem.dataset.index = index;

        thumbItem.innerHTML = isVideo
          ? `
            <div class="image-wrap" style="height:0;padding-bottom:100%;position:relative;">
              <a href="${url}" data-product-thumb class="product__thumb" data-index="${index}">
                <video src="${url}" muted style="width:100%;height:100%;object-fit:cover;"></video>
              </a>
            </div>`
          : `
            <div class="image-wrap" style="height:0;padding-bottom:100%;">
              <a href="${url}" data-product-thumb class="product__thumb" data-index="${index}">
                <img
                  class="animation-delay-${index} lazyautosizes"
                  data-widths="[120,360,540,720]"
                  data-aspectratio="1.0"
                  data-sizes="auto"
                  alt=""
                  loading="lazy"
                  src="${url}"
                  width="78"
                  height="78"
                >
              </a>
            </div>`;

        this.thumbsContainer.appendChild(thumbItem);
      });

      this.flkty = new Flickity(this.mainSlideshow, {
        adaptiveHeight: true,
        avoidReflow: true,
        cellAlign: "left",
        contain: true,
        wrapAround: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
      });

      this.mainSlideshow.flickityInstance = this.flkty;

      const thumbs = this.thumbsContainer.querySelectorAll("[data-product-thumb]");

      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", (e) => {
          e.preventDefault();
          const index = parseInt(thumb.dataset.index, 10);
          this.flkty.select(index);

          thumbs.forEach((t) => t.classList.remove("is-active"));
          thumb.classList.add("is-active");
        });
      });

      // Atualiza is-active quando o slider muda (swipe, drag, seta, etc.)
      this.flkty.on("select", () => {
        const selectedIndex = this.flkty.selectedIndex;

        thumbs.forEach((t) => {
          const thumbIndex = parseInt(t.dataset.index, 10);
          if (thumbIndex === selectedIndex) {
            t.classList.add("is-active");
          } else {
            t.classList.remove("is-active");
          }
        });
      });

      // Seleciona a primeira thumb como ativa por padrão
      if (thumbs.length > 0) {
        thumbs[0].classList.add("is-active");
      }

      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.flkty.resize();
        }, 150);
      });

      waitForGLightbox(() => {
        const lightbox = GLightbox({
          selector: ".glightbox",
          touchNavigation: true,
          loop: true,
          zoomable: true,
          slideEffect: "slide",
          keyboardNavigation: true,
        });
      });

      function waitForGLightbox(callback) {
        if (typeof GLightbox !== "undefined") {
          callback();
        } else {
          setTimeout(() => waitForGLightbox(callback), 100);
        }
      }
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
